import React, { Component } from "react";

class SearchableSelect extends Component {

  wrapperRef = React.createRef();

  state = {
    open: false,
    search: "",
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  toggle = () => {
    this.setState(prev => ({ open: !prev.open }));
  };

  handleSearch = (e) => {
    this.setState({ search: e.target.value });
  };

  selectOption = (value) => {
    this.setState({ open: false, search: "" });
    this.props.onChange({
      target: { value }
    });
  };

  handleClickOutside = (event) => {
    const { open } = this.state;

    if (
        open &&
        this.wrapperRef.current &&
        !this.wrapperRef.current.contains(event.target)
    ) {
        this.setState({ open: false, search: "" });
      }
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.disabled && this.props.disabled) {
      this.setState({ open: false });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  render() {
    const { options, value, disabled } = this.props;
    const { open, search } = this.state;

   const selectedOption = options.find(
    opt => String(opt.value) === String(value)
  );


    const filteredOptions = options.filter(opt =>
      opt.label.toLowerCase().includes(search.toLowerCase())
    );

    return (
      <div
        ref={this.wrapperRef}
        style={{ width: "180px", position: "relative" }}
      >
        {/* SELECT */}
        <div
          className="form-control22"
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            height: "30px",
            display: "flex",
            alignItems: "center",
            padding: "0 6px",
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? 0.5 : 1,
            backgroundColor: disabled ? "#f5f5f5" : "#fff"
          }}
          onClick={!disabled ? this.toggle : undefined}
        >
          {selectedOption ? selectedOption.label : "Select a system"}
        </div>

        {/* DROPDOWN */}
        {open && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              background: "#fff",
              border: "1px solid #ccc",
              zIndex: 1000,
              color: "#a18ee6ff",
              fontWeight: "bold",
            }}
          >
            <input
              type="text"
              disabled={disabled}
              placeholder=" Search "
              value={search}
              onChange={this.handleSearch}
              style={{
                width: "100%",
                boxSizing: "border-box",
                padding: "6px",
                fontSize: "12px",
                borderBottom: "1px solid #eee",
              }}
            />

            <div style={{ maxHeight: "180px", overflowY: "auto" }}>
              {filteredOptions.map(opt => (
                <div
                  key={opt.value}
                  onClick={() => this.selectOption(opt.value)}
                  style={{
                    padding: "6px",
                    fontSize: "12px",
                    cursor: disabled ? "not-allowed" : "pointer",
                    opacity: disabled ? 0.6 : 1
                  }}
                >
                  {opt.label}
                </div>
              ))}

              {filteredOptions.length === 0 && (
                <div style={{ padding: "6px", color: "#999" }}>
                  No results found
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SearchableSelect;
